import { Pipe, PipeTransform } from '@angular/core';
import {CurrencyService} from 'src/app/services/currency.service';

@Pipe({
    name: 'customCurrency',
    standalone: false
})
export class CustomCurrencyPipe implements PipeTransform {

  constructor(
      private currencyService: CurrencyService
  ) {}

  transform(value: number): string {
    return this.currencyService.getCurrency(value) ? this.currencyService.getCurrency(value).currencyCode : '';
  }

}
